// extracted by mini-css-extract-plugin
export var dropdownButton = "_2k-0";
export var fullWidthDropdownButton = "_2k-1";
export var icon = "_2k-3";
export var iconPlaceholder = "_2k-2";
export var menuItemRow = "_2k-8";
export var separator = "_2k-d";
export var shortcutContainer = "_2k-7";
export var shortcutIconLg = "_2k-6";
export var shortcutIconMd = "_2k-5";
export var shortcutIconSm = "_2k-4";
export var submenuChevron = "_2k-c";
export var submenuDropdown = "_2k-9";
export var submenuTriggerRow = "_2k-a";
export var submenuTriggerRowOpen = "_2k-b";